import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.classList.add('animate-fade-in-up');
    }
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/1a299141bc70106e41f004234d4cc904.jpg"
          alt="HASPICA Studio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6">
        <p className="animate-fade-in text-white/60 text-xs font-medium tracking-[0.25em] uppercase mb-6">
          Bordeaux, France
        </p>
        <h1 ref={titleRef} className="opacity-0 font-heading text-6xl md:text-8xl lg:text-9xl text-white font-light tracking-tight leading-none mb-8">
          Studio de<br />
          <em className="italic">design</em>
        </h1>
        <p className="animate-fade-in-up-delay-1 text-white/75 text-base md:text-lg font-light max-w-lg mx-auto leading-relaxed mb-10">
          HASPICA propose des services de design pour les entreprises et les particuliers. L'objectif est de créer des visuels modernes, clairs et efficaces.
        </p>
        <div className="animate-fade-in-up-delay-2 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-3.5 bg-white text-neutral-900 text-sm font-medium rounded-sm hover:bg-neutral-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Discuter de votre projet
          </Link>
          <Link
            to="/a-propos"
            className="px-8 py-3.5 border border-white/60 text-white text-sm font-medium rounded-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            À propos du studio
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-fade-in-up-delay-3">
        <div className="w-px h-12 bg-white/30 relative overflow-hidden">
          <div
            className="absolute top-0 left-0 w-full bg-white/80"
            style={{
              height: '40%',
              animation: 'scrollLine 2s ease-in-out infinite',
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(300%); }
        }
      `}</style>
    </section>
  );
}
